<template>
    <div class="main-board">
        <div class="main-board__head">
            <h3 class="text-28 text-md-22">자료실</h3>
            <router-link to="/center/reference" class="main-board__more"><span class="d-sr-only">더보기</span></router-link>
        </div>
        <div class="main-board__body">
            <div class="main-board-items">
                <div v-if="!items.length" class="main-board-item">
                    게시글이 없습니다.
                </div>
                <router-link v-for="{ _id, subject, createdAt } in items" :key="_id" :to="`/center/reference/${_id}`" class="main-board-item">
                    <div class="main-board-item__tit">{{ subject }}</div>
                    <span class="main-board-item__date">{{ createdAt.toDate() }}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
export default {
    computed: {
        items() {
            return [...(this.fixed || []), ...(this.boards || [])];
        },
    },
    data() {
        return {
            limit: 5,
            fixed: [],
            boards: [],
        };
    },
    methods: {
        async search() {
            try {
                let { limit } = this;
                var { boards: fixed } = await api.v1.boards.gets({
                    headers: { limit },
                    params: { isNotice: true, code: "yknowledge-reference" },
                });
                this.fixed = fixed;

                limit -= fixed.length;
                if (limit) {
                    var { boards } = await api.v1.boards.gets({
                        headers: { limit },
                        params: { isNotice: false, code: "yknowledge-reference" },
                    });

                    this.boards = boards;
                }
            } catch (error) {
                this.handleError(error);
            }
        },
    },
    mounted() {
        this.search();
    },
};
</script>

<style></style>
